import { CampaignBriefTemplateLabels } from "../../../../../types/templates/campaign-brief/campaign-brief-template-labels.constant";

import { matchByValue } from "../../../../filters/inputs/autocomplete/autocomplete.functions";

import { IForm } from "../../../form-modal/form-modal.types";
import { TextInput } from "../../../form-modal/inputs/text-input/text-input.component";
import { Autocomplete } from "../../../form-modal/inputs/autocomplete/autocomplete.component";
import { Checkbox } from "../../../form-modal/inputs/checkbox/checkbox.component";

export const NewCampaignBriefForm = (props: IForm) => {
  return (
    <>
      <TextInput form={props.form} label="Campaign Brief Name" name="name" required />
      <Autocomplete
        form={props.form}
        fullWidth
        label="Template"
        name="resourcetype"
        optionSelected={matchByValue}
        options={CampaignBriefTemplateLabels}
        placeholder="Select a template"
        required
      />
      <Checkbox form={props.form} label="Under NDA?" name="is_under_nda" />
    </>
  );
};
